import React, { useReducer, useState } from "react";
import "./personnel.scss";
import { Box, Divider, Skeleton, Tooltip } from "@mui/material";
import {
  AccountCircleRounded,
  ArrowBackRounded,
  CancelRounded,
  CheckCircle,
  Person,
  PictureAsPdfRounded,
  Print,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

import Delete from "../../../component/dialog/delete/Delete.tsx";
import SearchBar from "../../../component/searchBar/Search.tsx";
import UpdatePersonnel from "./UpdatePersonnel.tsx";
import SinglePersonnel from "./singlePersonnel.tsx";
// import NewPersonnel from "./newPersonnel.tsx";
import { catchErrorApiCall } from "../../../_services/apiUtils.js";
import {
  domaineType,
  fonctionType,
  gradeType,
  PersonnelType,
  requestType,
  UserType,
} from "../../../types/GlobalType.ts";
import { API_PERSONNEL } from "../../../apiCaller/personnel.Caller.js";
import { accountService } from "../../../_services/accountServices.js";
import { orderBy } from "lodash";
import toast from "react-hot-toast";
import { personnelContext } from "../../../context/AppContext.js";
import { API_CONFIG } from "../../../apiCaller/configuration.Caller.js";
import ConnexionErrorDiv from "../../../component/nodata/ConnexionErrorDiv.js";
import user_api from "../../../apiCaller/user.Caller.js";

const Personnel = () => {
  const [openArchiveEleve, setopenArchivePersonnel] =
    React.useState<Boolean>(false);

  const [openActivateEleve, setopenActivatePersonnel] =
    React.useState<Boolean>(false);

  const [itemId, setItemId] = useState<string | number>();

  const [loadingDeleteBtn, setLoadingDeleteBtn] =
    React.useState<boolean>(false);

  const [dataPersonnel, setDataPersonnel] = useState<PersonnelType[]>([]);
  const [dataAccountUser, setDataAccountUser] = useState<UserType[]>([]);
  const [dataFonction, setDataFonction] = useState<fonctionType[]>([]);
  const [dataGrade, setDataGrade] = useState<gradeType[]>([]);
  const [dataDomaine, setDataDomaine] = useState<domaineType[]>([]);

  const [accountExists, setaccountExists] = useState<UserType | undefined>();

  const [singleDataPersonnel, setsingleDataPersonnel] =
    useState<PersonnelType>();

  const [stateReload, dispatchReload] = useReducer((x) => x + 1, 0);

  // const [openAdd, setOpenAdd] = useState<Boolean>(false);
  const [openSingle, setOpenSingle] = useState<Boolean>(false);
  const [openUpdate, setOpenUpdate] = useState<Boolean>(false);
  const [searchValue, setsearchValue] = useState<string>("");

  // const validatePhoneNumber = (phoneNumber: any) => {
  //   const phoneNumberPattern =
  //     /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;
  //   return phoneNumberPattern.test(phoneNumber);
  // };

  //phone number state
  // const [phoneNumber, setPhoneNumber] = useState("");
  // const [validdNumber, setValidNumber] = useState<boolean>(true);
  // const handleChangePhone = (input: string) => {
  //   setPhoneNumber(input);
  //   setValidNumber(validatePhoneNumber(input));
  // };

  const navigate = useNavigate();

  const [state, setState] = React.useState<requestType>({
    isLoading: false,
    errorMessage: false,
    successMessage: false,
  });

  const fetchAllPersonnel = async () => {
    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      const response = await API_PERSONNEL.PERSONNEL.getAll(token);
      setDataPersonnel(response.data.data);

      setState({ ...state, isLoading: false });
    } catch (error) {
      setState({ ...state, isLoading: false });

      if (error.code === "ERR_NETWORK") {
        return setState({
          isLoading: false,
          successMessage: false,
          errorMessage: "ERR_NETWORK",
        });
      }
      catchErrorApiCall(error);
    }
  };
  const fetchAccountUser = async () => {
    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      const response = await user_api.getAll(token);
      setDataAccountUser(response.data.data);

      setState({ ...state, isLoading: false });
    } catch (error) {
      setState({ ...state, isLoading: false });

      if (error.code === "ERR_NETWORK") {
        return setState({
          isLoading: false,
          successMessage: false,
          errorMessage: "ERR_NETWORK",
        });
      }
      catchErrorApiCall(error);
    }
  };

  const fetchAllFonction = async () => {
    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      const response = await API_CONFIG.FONCTION.getAll(token);
      setDataFonction(response.data.data);

      setState({ ...state, isLoading: false });
    } catch (error) {
      setState({ ...state, isLoading: false });
      if (error.code === "ERR_NETWORK") {
        return setState({
          isLoading: false,
          successMessage: false,
          errorMessage: "ERR_NETWORK",
        });
      }
      catchErrorApiCall(error);
    }
  };
  const fetchAllGrade = async () => {
    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();
    if (!token) return navigate("/login");

    try {
      const response = await API_CONFIG.GRADE.getAll(token);
      setDataGrade(response.data.data);

      setState({ ...state, isLoading: false });
    } catch (error) {
      setState({ ...state, isLoading: false });
      if (error.code === "ERR_NETWORK") {
        return setState({
          isLoading: false,
          successMessage: false,
          errorMessage: "ERR_NETWORK",
        });
      }
      catchErrorApiCall(error);
    }
  };
  const fetchAllDomaine = async () => {
    setState({ isLoading: true, errorMessage: null, successMessage: null });

    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      const response = await API_CONFIG.DOMAINE_ETUDE.getAll(token);
      setDataDomaine(response.data.data);

      setState({ ...state, isLoading: false });
    } catch (error) {
      setState({ ...state, isLoading: false });
      if (error.code === "ERR_NETWORK") {
        return setState({
          isLoading: false,
          successMessage: false,
          errorMessage: "ERR_NETWORK",
        });
      }
      catchErrorApiCall(error);
    }
  };

  const handleActivatePersonnel = async (id: string | number | undefined) => {
    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      await API_PERSONNEL.PERSONNEL.active(id, token);
      setLoadingDeleteBtn(false);
      setopenActivatePersonnel(false);
      dispatchReload();
      toast.success("Personnel activé avec succes", {
        style: {
          zIndex: 9999,
        },
      });
    } catch (error) {
      setLoadingDeleteBtn(false);
      if (error.code === "ERR_NETWORK") {
        return setState({
          isLoading: false,
          successMessage: false,
          errorMessage: "ERR_NETWORK",
        });
      }
      catchErrorApiCall(error);
    }
  };
  const handleArchivePersonnel = async (id: string | number | undefined) => {
    let token = accountService.getToken();

    if (!token) {
      toast.error("Votre session a expiré, veuillez vous reconnectez", {
        style: {
          backgroundColor: "#630f0f", // Custom background color
          color: "white", // Text color
          fontSize: "12px", // Font size
          zIndex: 9999,
        },
      });

      accountService.logout();
      return navigate("/", { replace: true });
    }
    try {
      let response = await API_PERSONNEL.PERSONNEL.desactive(id, token);
      console.log(response);
      setLoadingDeleteBtn(false);
      setopenArchivePersonnel(false);
      dispatchReload();
      toast.success("Personnel archivé avec succès", {
        style: {
          zIndex: 9999,
        },
      });
    } catch (error) {
      console.log(error);
      setLoadingDeleteBtn(false);

      if (error.code === "ERR_NETWORK") {
        return setState({
          isLoading: false,
          successMessage: false,
          errorMessage: "ERR_NETWORK",
        });
      }
      catchErrorApiCall(error);
    }
  };

  let sortedData: PersonnelType[] = [];
  if (dataPersonnel.length > 0) {
    sortedData = orderBy(dataPersonnel, ["nom"], ["asc"]);
  }

  const skeletonHeader = (
    <div className="configuration_">
      <Skeleton
        variant="rounded"
        height={25}
        width={250}
        sx={{ marginTop: "5px", marginRight: "10px" }}
      />
      <Skeleton
        variant="rounded"
        height={25}
        width={150}
        sx={{ marginTop: "5px", marginRight: "10px" }}
      />
    </div>
  );
  const skeletonSearchSection = (
    <div className="input-container">
      <Skeleton
        variant="rounded"
        height={30}
        width={250}
        sx={{ marginTop: "5px" }}
      />

      <div className="right_list_part">
        <Skeleton
          variant="rounded"
          height={30}
          width={"90%"}
          sx={{ marginTop: "5px" }}
        />
        <Skeleton
          variant="circular"
          height={30}
          width={30}
          sx={{ marginTop: "5px" }}
        />
      </div>
    </div>
  );
  const skeletonTable = (
    <Skeleton
      sx={{ marginTop: "10px" }}
      variant="rounded"
      height={500}
      width={"100%"}
    />
  );

  React.useEffect(() => {
    fetchAllPersonnel();
    fetchAllFonction();
    fetchAllGrade();
    fetchAllDomaine();
    fetchAccountUser();
  }, [stateReload]);

  return (
    <>
      {state.errorMessage === "ERR_NETWORK" ? (
        <ConnexionErrorDiv />
      ) : (
        <Box
          bgcolor="#eee"
          flex={5}
          p={1}
          sx={{ marginLeft: "200px", marginTop: "66px" }}
        >
          {state.isLoading ? (
            skeletonHeader
          ) : (
            <div className="configuration_">
              <div className="homeMenuCong">
                {/* <Link to="/" style={{ marginTop: "5px" }}> */}
                <ArrowBackRounded
                  sx={{
                    color: "#0091EA",
                    backgroundColor: "#fff",
                    borderRadius: "50%",
                    mt: "5px",
                    cursor: "pointer",
                  }}
                  onClick={() => navigate("/configuration/configuration")}
                />
                {/* </Link> */}
                <div className="homeTitleItem">
                  <span className="homeTitle"> Configuration</span>
                </div>
                <div className="homeTitleItem">
                  <Person sx={{ color: "#1565C0", mr: "10px" }} />
                  <span className="homeTitleSmall">Personnel </span>
                </div>
              </div>
              <div className="right__">
                {/* <button
              className="add_button_pers"
              onClick={() => setOpenAdd(true)}
            >
              <Tooltip title="Nouveau élève">
                <PersonAddAlt1 className="ico" />
              </Tooltip>
              Nouveau
            </button> */}
                <button className="add_button_pers">
                  <Tooltip title="Exporter PDF">
                    <PictureAsPdfRounded className="ico" />
                  </Tooltip>
                  exporter
                </button>
              </div>
            </div>
          )}

          <Divider sx={{ marginTop: "5px", marginBottom: "10px" }} />

          <div className="card_Classe">
            {state.isLoading ? (
              skeletonSearchSection
            ) : (
              <div className="input-container">
                <h2 className="card-title">Liste</h2>
                <div className="right_list_part">
                  <SearchBar
                    searchValue={searchValue}
                    setSearchValue={setsearchValue}
                    label="Rechercher..."
                  />
                  <button className="add_button_pers">
                    <Tooltip title="Imprimer">
                      <Print className="ico" />
                    </Tooltip>
                  </button>
                </div>
              </div>
            )}

            {state.isLoading ? (
              skeletonTable
            ) : (
              <div className="table_component" role="region">
                <table>
                  <thead>
                    <tr>
                      <th>Id</th>
                      <th>Noms</th>
                      <th>Fonction</th>
                      <th>Domaine</th>
                      <th className="headerSection">Status</th>
                      <th className="headerSection">Compte</th>
                      <th className="actionHeader"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {sortedData
                      .filter(
                        (value) =>
                          value.nom
                            ?.toLowerCase()
                            .includes(searchValue.toLowerCase()) ||
                          value.postnom
                            ?.toLowerCase()
                            .includes(searchValue.toLowerCase()) ||
                          value.prenom
                            ?.toLowerCase()
                            .includes(searchValue.toLowerCase()) ||
                          value.fonction_designation
                            ?.toLowerCase()
                            .includes(searchValue.toLowerCase()) ||
                          value.domaine_designation
                            ?.toLowerCase()
                            .includes(searchValue.toLowerCase())
                      )
                      .map((item, index) => {
                        let personnelId = item.personnel_id;
                        let isAccountExisted = dataAccountUser.find(
                          (account) => account.personnel_id === personnelId
                        );

                        return (
                          <tr key={index}>
                            <td
                              onClick={() => {
                                setsingleDataPersonnel(item);
                                setOpenSingle(true);
                                setaccountExists(isAccountExisted);
                              }}
                            >
                              {index + 1}
                            </td>
                            <td
                              className="userName"
                              onClick={() => {
                                setsingleDataPersonnel(item);
                                setOpenSingle(true);
                                setaccountExists(isAccountExisted);
                              }}
                            >
                              <div className="userName">
                                <AccountCircleRounded />
                                {`${item.nom?.toUpperCase()} ${item.postnom?.toUpperCase()} ${item.prenom?.toUpperCase()}`}
                              </div>
                            </td>
                            <td
                              onClick={() => {
                                setsingleDataPersonnel(item);
                                setOpenSingle(true);
                                setaccountExists(isAccountExisted);
                              }}
                            >
                              {item.fonction_designation}
                            </td>
                            <td
                              onClick={() => {
                                setsingleDataPersonnel(item);
                                setOpenSingle(true);
                                setaccountExists(isAccountExisted);
                              }}
                            >
                              {item.domaine_designation}
                            </td>
                            <td className="statusSection">
                              <span>
                                {item.personnel_status ? (
                                  <Tooltip title="Activé" placement="left">
                                    <CheckCircle
                                      style={{
                                        color: "#28a745",
                                        fontSize: "14px",
                                      }}
                                    />
                                  </Tooltip>
                                ) : (
                                  <Tooltip title="Archivé" placement="left">
                                    <CancelRounded
                                      style={{
                                        color: "#7f1d18",
                                        fontSize: "14px",
                                      }}
                                    />
                                  </Tooltip>
                                )}
                              </span>
                            </td>
                            <td className="statusSection">
                              <span>
                                {isAccountExisted ? (
                                  <Tooltip title="Activé" placement="left">
                                    <CheckCircle
                                      style={{
                                        color: "#28a745",
                                        fontSize: "14px",
                                      }}
                                    />
                                  </Tooltip>
                                ) : (
                                  <Tooltip title="Archivé" placement="left">
                                    <CancelRounded
                                      style={{
                                        color: "#7f1d18",
                                        fontSize: "14px",
                                      }}
                                    />
                                  </Tooltip>
                                )}
                              </span>
                            </td>
                            <td>
                              <div className="actionSection">
                                {item.personnel_status ? (
                                  <span
                                    className="archiveP"
                                    onClick={() => {
                                      setItemId(item.personnel_id);
                                      setopenArchivePersonnel(true);
                                    }}
                                  >
                                    Archiver
                                  </span>
                                ) : (
                                  <span
                                    className="archiveP"
                                    onClick={() => {
                                      setItemId(item.personnel_id);
                                      setopenActivatePersonnel(true);
                                    }}
                                  >
                                    Activer
                                  </span>
                                )}

                                <span
                                  className="editP"
                                  onClick={() => {
                                    setsingleDataPersonnel(item);
                                    setOpenUpdate(true);
                                  }}
                                >
                                  Editer
                                </span>
                              </div>
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </Box>
      )}

      {openUpdate && (
        <UpdatePersonnel
          setOpen={setOpenUpdate}
          data={singleDataPersonnel}
          dataFonction={dataFonction}
          dataGrade={dataGrade}
          dataDomaine={dataDomaine}
          dispatchReload={dispatchReload}
        />
      )}
      {/* {openAdd && <NewPersonnel setOpen={setOpenAdd} />} */}

      {openSingle && (
        <personnelContext.Provider value={singleDataPersonnel}>
          <SinglePersonnel
            setOpen={setOpenSingle}
            accountExists={accountExists}
            dispatchReload={dispatchReload}
          />
        </personnelContext.Provider>
      )}

      {openActivateEleve && (
        <Delete
          setOpen={setopenActivatePersonnel}
          itemId={itemId}
          label={"Voulez-vous vraiment activer ce personnel?"}
          handleDelete={handleActivatePersonnel}
          loadingDeleteBtn={loadingDeleteBtn}
          setLoadingDeleteBtn={setLoadingDeleteBtn}
          title="Activation"
        />
      )}
      {openArchiveEleve && (
        <Delete
          setOpen={setopenArchivePersonnel}
          itemId={itemId}
          label={"Voulez-vous vraiment archiver ce personnel?"}
          handleDelete={handleArchivePersonnel}
          loadingDeleteBtn={loadingDeleteBtn}
          setLoadingDeleteBtn={setLoadingDeleteBtn}
          title="Archivage"
        />
      )}
    </>
  );
};

export default Personnel;
